import gql from 'graphql-tag';

export const SHOW_PAN = gql`
  query getTransactionHashExceptionPan($tx_hash_internal_id: String!) {
    transactionHashExceptionPan(tx_hash_internal_id: $tx_hash_internal_id) {
      pan
    }
  }
`;
